import { type App } from 'vue';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';

export { default as routes } from './routes';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                CreateReport: () => import('./partials/CreateReport.vue'),
                RiskAnalysisExpand: () =>
                    import('./partials/RiskAnalysisExpand.vue'),
                SelectVerificationConfiguration: () =>
                    import('./partials/SelectVerificationConfiguration.vue'),
                UpdateEntries: () => import('./partials/UpdateEntries.vue'),
                AssignProductCategoryToProduct: () =>
                    import(
                        './partials/todos/AssignProductCategoryToProduct.vue'
                    ),
                AssignSupplierBranchToProduct: () =>
                    import(
                        './partials/todos/AssignSupplierBranchToProduct.vue'
                    ),
                ProvideRequiredProductPredicateValues: () =>
                    import(
                        './partials/todos/ProvideRequiredProductPredicateValues.vue'
                    ),
                ResolveAnalysisReportProductRiskPredicateValue: () =>
                    import(
                        './partials/todos/ResolveAnalysisReportProductRiskPredicateValue.vue'
                    ),
                SelectAnalysisReportProducts: () =>
                    import('./partials/todos/SelectAnalysisReportProducts.vue'),
                SetRiskProbabilityValueForRiskConfiguration: () =>
                    import(
                        './partials/todos/SetRiskProbabilityValueForRiskConfiguration.vue'
                    ),
                SetThreatSeverityValueForRiskConfiguration: () =>
                    import(
                        './partials/todos/SetThreatSeverityValueForRiskConfiguration.vue'
                    ),
                SelectedProductsExpanded: () =>
                    import('./partials/SelectedProductsExpanded.vue'),
                ReportState: () => import('./partials/ReportState.vue'),
            },
            '@precon-tools-suite-by-shared/gino-analysis-reports-feature/partials/'
        );
    },
};
